import {
  Directive,
  HostListener, Input,
} from "@angular/core";

@Directive({
  selector: '[lm-keyboard-event-blocker]',
  standalone: false,
})
export class LMKeyboardEventBlockerDirective {
  @Input('isReadOnly') isReadOnly;

  @HostListener('click', ['$event'])
  @HostListener('keydown', ['$event'])
  blockEvents(event: Event): void {
    if(this.isReadOnly) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}